import { useLocation, useNavigate } from 'react-router-dom';

export const useCategoryNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (categoryId: string) => {
    navigate(`/category/${categoryId}${location.search}`);
  };
};
